import ApiService from '@/services/api.service'

const MenuService = {

    getMenu(){
        return ApiService.get(`/Menus?Device=WEB&LoadUserSelectedModule=true&Operation=LoadingMainMenu`);
    }
}

export default MenuService;